import React, { useRef } from 'react'
import cx from 'classnames'
import { useCountdown } from 'hooks'
import { useDevice } from 'device'
import { constants } from 'helpers'

import { Text } from 'components/dataDisplay'

import messages from './messages'
import s from './StyledTimer.scss'


const baseBoxClassName = 'flex items-center justify-center bg-light-beige radius-5'

const paramsBySize = {
  36: {
    textStyle: 'text-sh6',
    format: `
      [<div class="mr-8"><div class="${s.box36} ${baseBoxClassName}">] mm [</div><div class="text-t3">minutes</div></div>:]
      [<div class="ml-8"><div class="${s.box36} ${baseBoxClassName}">] ss [</div><div class="text-t3">seconds</div></div>]
    `,
  },
  56: {
    textStyle: 'text-sh3',
    format: `
      [<div class="mr-8"><div class="${s.box56} ${baseBoxClassName}">] mm [</div><div class="mt-4 text-p5">minutes</div></div>:]
      [<div class="ml-8"><div class="${s.box56} ${baseBoxClassName}">] ss [</div><div class="mt-4 text-p5">seconds</div></div>]
    `,
  },
}

type StyledTimerProps = {
  className?: string
  cookieName?: string
  withTitle?: boolean
  size: 36 | 56
}

const StyledTimer: React.FC<StyledTimerProps> = (props) => {
  const { className, withTitle, size = 56, cookieName = constants.cookieNames.rootCountdown } = props
  const { isMobile } = useDevice()

  const countdownRef = useRef<HTMLDivElement>()

  const { format, textStyle } = paramsBySize[size]

  const { countdownMessage, isExpired } = useCountdown({
    nodeRef: countdownRef,
    cookieName,
    format,
    message: messages.time,
  })

  if (isExpired) {
    return null
  }

  return (
    <div className={className}>
      {
        withTitle && (
          <Text
            className={isMobile ? 'mb-12' : 'mb-24'}
            message={messages.title}
            style={isMobile ? 't1' : 'sh3'}
            color={isMobile ? 'white' : 'gold-70'}
          />
        )
      }
      <div
        className={cx('inline-flex items-baseline text-center', textStyle)}
        ref={countdownRef}
        dangerouslySetInnerHTML={{ __html: countdownMessage }}
      />
    </div>
  )
}


export default React.memo(StyledTimer)
